import React, { useState, useEffect } from 'react'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Checkbox from '@material-ui/core/Checkbox'
import Button from '@material-ui/core/Button'
import ToolTip from '@material-ui/core/Tooltip'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import { CgClose } from 'react-icons/cg'
import { useMutation } from '@apollo/client'
import { useQuery } from '@apollo/client'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import CircularProgress from '@material-ui/core/CircularProgress'

import { Q_ENVIRONMENT_NAMES } from 'graphql/query'
import { MC_ENV } from 'graphql/mutations'
import styles from '../environment.module.scss'

const EnvironmentCreateForm = ({ setCreate, update, loading }) => {
  const [name, setName] = useState('')
  const [exterior, setExterior] = useState(false)
  const [natural, setNatural] = useState(false)
  const [env, setEnv] = useState()
  const [names, setNames] = useState([])
  const [nameExists, setNameExists] = useState(false)

  const refetch_names = useQuery(Q_ENVIRONMENT_NAMES).refetch

  // TODO: implement [call, { data, loading, errors }]
  const [call] = useMutation(MC_ENV)

  const onSubmit = () => {
    loading(true)
    call({
      variables: {
        // exterior,
        name,
        env,
        // natural,
      },
    })
      .then(() => {
        setCreate(false)
        update()
      })
      .catch(err => console.error(err))
  }
  useEffect(() => {
    refetch_names() &&
      refetch_names().then(res => {
        const temp_names = []
        res.data.getEnvironment.forEach(i => temp_names.push(i.name))
        setNames(temp_names)
      })
  }, [refetch_names])

  return (
    <div className={styles.form}>
      <Typography variant="h6" component="h2">
        Environment create form
      </Typography>
      <ToolTip
        title="type in name of the enviroment map"
        placement="top-end"
        arrow
      >
        <FormControl error={nameExists}>
          <TextField
            // variant="outlined"
            label="Name"
            id="name"
            value={name}
            error={nameExists}
            onChange={v => {
              if (names.includes(v.target.value)) {
                setNameExists(true)
              } else {
                setNameExists(false)
              }
              setName(v.target.value)
            }}
            fullWidth
          />{' '}
          <FormHelperText>
            {nameExists
              ? `This environment name, ${name} already exists`
              : 'provide the environment name'}
          </FormHelperText>
        </FormControl>
      </ToolTip>
      <ToolTip
        title="select the check box if the envirenment is exterior"
        placement="right"
        arrow
      >
        <div className={styles.switch}>
          <Checkbox
            checked={exterior}
            onChange={v => setExterior(v.target.checked)}
          />
          <Typography className={styles.switchTypo}>Exterior</Typography>
        </div>
      </ToolTip>
      <ToolTip
        title="select the check box if the lighting is natural"
        placement="right"
        arrow
      >
        <div className={styles.switch}>
          <Checkbox
            checked={natural}
            onChange={v => setNatural(v.target.checked)}
          />
          <Typography className={styles.switchTypo}>Natural</Typography>
        </div>
      </ToolTip>
      <ToolTip title="upload senv format files" placement="top-end" arrow>
        <ButtonGroup fullWidth>
          <Button
            autoFocus
            margin="dense"
            id="environment"
            label="Environment"
            type="file"
            // variant="contained"
            component="label"
            className={styles.envButton}
          >
            {env ? `Selected ${env.name}` : 'Select *.senv File'}
            <input
              type="file"
              onChange={e => {
                setEnv(e.target.files.item(0))
              }}
              accept=".senv"
              hidden
            />
          </Button>
          {env && (
            <Button
              onClick={() => setEnv()}
              className={styles.width}
              // variant="contained"
            >
              <CgClose />
            </Button>
          )}
        </ButtonGroup>
      </ToolTip>
      <ToolTip
        title="create enviroment data in the backend api"
        placement="top-end"
        arrow
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() => onSubmit()}
          disabled={nameExists}
        >
          Create Enviromnent Data
        </Button>
      </ToolTip>
    </div>
  )
}

export default EnvironmentCreateForm
